import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import styles from './DialComponent.module.scss';
import boddVariables from '../../../../variables.module.scss';

export interface DialComponentProps {
    name: string,
    value: number,
    min: number,
    max: number,
    unit: string | undefined,
    displayValue: string,
    children: React.ReactNode,
}

const clamp = (value: number, max: number) => {
    if (value > max) return max;
    return value;
};

const DialComponent: FC<DialComponentProps> = (props) => {
    const { min, max, value, displayValue, unit, name, children } = props;
    const degrees = clamp(((value - min!) / (max! - min!)) * 260, 260); // dial goes from 0 to 260
    const radians = (degrees + 140) * (Math.PI / 180);
    const radius = 60;
    const xPos = radius * Math.cos(radians);
    const yPos = radius * Math.sin(radians);
    const valLeft = xPos;
    const valTop = yPos + 43;

    return (
        <Stack
            data-testid="DialComponent"
            direction="column"
            className={styles.DialComponent}
            sx={{
                minWidth: '120px',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontSize: '16px',
                    lineHeight: '21px',
                    color: boddVariables.boddBlack,
                    mx: 1.5,
                    pb: '21px',
                    height: '46px',
                    textAlign: 'center',
                }}
            >
                {name}
            </Typography>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                className={styles.DialImage}
            >
                <Box
                    sx={{
                        height: 10,
                        width: 10,
                        border: '2px',
                        borderStyle: 'solid',
                        borderColor: boddVariables.grey50,
                        backgroundColor: boddVariables.boddBlack,
                        position: 'relative',
                        left: `${valLeft}px`,
                        borderRadius: '50%',
                        top: `${valTop}px`,
                    }}
                />
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '22px',
                        lineHeight: '28px',
                        color: '#000000',
                        mt: 2,
                    }}
                >
                    {displayValue}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        height: '18px',
                        color: '#5E5D5A',
                    }}
                >
                    {unit ?? ''}
                </Typography>
            </Stack>
            <Stack
                direction="row"
                justifyContent="center"
                alignSelf="stretch"
                sx={{ pb: '8px' }}
            >
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: boddVariables.boddBlack,
                        mr: '30px',
                    }}
                >
                    {min}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: boddVariables.boddBlack,
                        ml: '30px',
                    }}
                >
                    {max}
                </Typography>
            </Stack>
            {children}
        </Stack>
    );
};

export default DialComponent;
